import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizes: [],
};

export const quizSlice = createSlice({
  name: "Quiz",
  initialState,
  reducers: {
    setQuiz: (state, action) => {
      state.quizes = action.payload;
    },
  },
});

export const { setQuiz } = quizSlice.actions;
export const quizReducer = quizSlice.reducer;